export const MEETING_SYNC = 'meetingSync';
export const WEBINAR_SYNC = 'webinarSync';
export const EXCLUSIONS = 'exclusions';
export const CONTACTS = 'contact';
export const RECORDINGS = 'recording';
export const PER_PAGE_COUNTS = [10, 25, 50];
export const MAX_VISIBLE_PAGE_BUTTONS = 5;
export const SortDirection = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  NONE: 'none'
};
export const ColumnNamesToSort = {
  TOPIC: 'topic',
  SCHEDULED_DATE: 'scheduledDate'
};
export const UserSyncStatus = {
  ALL: 'ALL',
  SYNCING: 'SYNCING',
  NOT_SYNCING: 'NOT_SYNCING'
};
export const GlobalSyncStatus = {
  NOT_SYNC: 'NONE',
  ALL_SYNC: 'ALL',
  SOME_SYNC: 'SOME'
};
export const EventType = {
  MEETING: 'MEETING',
  WEBINAR: 'WEBINAR'
};
export const ExclusionTypes = {
  contact: 'CONTACT',
  recording: 'RECORDING'
};
export const ChirpErrorType = {
  NOT_FOUND: 'NOT_FOUND',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  RELATED_CALL_ENGAGEMENT_ID_NOT_FOUND: 'RELATED_CALL_ENGAGEMENT_ID_NOT_FOUND',
  MEETING_NOT_FOUND: 'MEETING_NOT_FOUND',
  THIRD_PARTY_OUTAGE_ERROR: 'THIRD_PARTY_OUTAGE_ERROR',
  FORBIDDEN_ERROR: 'FORBIDDEN_ERROR'
};
export const ChirpSubCategoryError = {
  ERROR_WITH_MESSAGE_OUTPUT_TO_USER: 'ERROR_WITH_MESSAGE_OUTPUT_TO_USER',
  ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER: 'ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER'
};
export const ErrorsType = {
  GENERIC_ERROR: 'GENERIC_ERROR',
  INTEGRATION_SETTINGS_NOT_FOUND_ERROR: 'INTEGRATION_SETTINGS_NOT_FOUND_ERROR',
  GET_NEWLY_WEBINAR_SYNC_ERROR: 'GET_NEWLY_WEBINAR_SYNC_ERROR',
  GET_GLOBAL_SYNC_WEBINARS_ERROR: 'GET_GLOBAL_SYNC_WEBINARS_ERROR',
  GET_USER_RECORDING_SYNC_WEBINAR_ERROR: 'GET_USER_RECORDING_SYNC_WEBINAR_ERROR',
  GET_WEBINARS_ERROR: 'GET_WEBINARS_ERROR',
  SAVE_WEBINAR_SETTINGS_ERROR: 'SAVE_WEBINAR_SETTINGS_ERROR',
  SYNC_WEBINAR_ERROR: 'SYNC_WEBINAR_ERROR',
  GET_EXCLUSION_ERROR: 'GET_EXCLUSION_ERROR',
  SAVE_EXCLUSION_ERROR: 'SAVE_EXCLUSION_ERROR',
  GET_USERS_ERROR: 'GET_USERS_ERROR',
  GET_USER_SYNC_SETTINGS_ERROR: 'GET_USER_SYNC_SETTINGS_ERROR',
  SAVE_USER_SYNC_SETTINGS_ERROR: 'SAVE_USER_SYNC_SETTINGS_ERROR',
  INTEGRATION_DISCONNECTED_FOR_USERS_ERROR: 'INTEGRATION_DISCONNECTED_FOR_USERS_ERROR',
  INTEGRATION_DISCONNECTED_FOR_WEBINARS_ERROR: 'INTEGRATION_DISCONNECTED_FOR_WEBINARS_ERROR',
  SAVE_WEBINAR_SETTINGS_AT_DISCONNECTED_STATUS_ERROR: 'SAVE_WEBINAR_SETTINGS_AT_DISCONNECTED_STATUS_ERROR',
  SYNC_WEBINAR_AT_DISCONNECTED_STATUS_ERROR: 'SYNC_WEBINAR_AT_DISCONNECTED_STATUS_ERROR',
  ERROR_WITH_MESSAGE_OUTPUT_TO_USER: 'ERROR_WITH_MESSAGE_OUTPUT_TO_USER',
  ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER: 'ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER',
  THIRD_PARTY_OUTAGE_FOR_USERS_ERROR: 'THIRD_PARTY_OUTAGE_FOR_USERS_ERROR',
  THIRD_PARTY_OUTAGE_FOR_WEBINARS_ERROR: 'THIRD_PARTY_OUTAGE_FOR_WEBINARS_ERROR',
  THIRD_PARTY_OUTAGE_FOR_WEBINARS_FORM_ERROR: 'THIRD_PARTY_OUTAGE_FOR_WEBINARS_FORM_ERROR',
  INTEGRATION_DISCONNECTED_FOR_WEBINAR_FORMS_ERROR: 'INTEGRATION_DISCONNECTED_FOR_WEBINAR_FORMS_ERROR',
  WEBINAR_FORMS_PERMISSIONS_ERROR: 'WEBINAR_FORMS_PERMISSIONS_ERROR',
  WEBINAR_FORMS_APP_STATUS_ERROR: 'WEBINAR_FORMS_APP_STATUS_ERROR',
  MEETINGS_NOT_FOUND_ERROR: 'MEETINGS_NOT_FOUND_ERROR',
  THIRD_PARTY_OUTAGE_FOR_MEETINGS_SEARCH: 'THIRD_PARTY_OUTAGE_FOR_MEETINGS_SEARCH',
  MEETINGS_DEFAULT_ERROR: 'MEETINGS_DEFAULT_ERROR',
  MEETINGS_SYNC_INTERNAL_ERROR: 'MEETINGS_SYNC_INTERNAL_ERROR'
};